<template>
  <div class="toothmapshow custom-class">
    <div class="heng"></div>
    <div class="shu"></div>
    <div class="lt">
      <template v-for="(item, index) in showlistleft" :key="index">
        <span v-if="tooth.lt.includes(item)">
          {{ item }}
        </span>
      </template>
    </div>
    <div class="rt">
      <template v-for="(item, index) in showlistright" :key="index">
        <span v-if="tooth.rt.includes(item)"> {{ item }} </span>
      </template>
    </div>
    <div class="lb">
      <template v-for="(item, index) in showlistleft" :key="index">
        <span v-if="tooth.lb.includes(item)"> {{ item }} </span>
      </template>
    </div>
    <div class="rb">
      <template v-for="(item, index) in showlistright" :key="index">
        <span v-if="tooth.rb.includes(item)"> {{ item }} </span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "h5toothmap",
  props: {
    toothPosition: {
      type: String,
      default: "",
    },
  },
  components: {},
  data: function () {
    return {
      showlistleft: [
        "8",
        "7",
        "6",
        "5",
        "E",
        "4",
        "D",
        "3",
        "C",
        "2",
        "B",
        "1",
        "A",
      ],
      showlistright: [
        "A",
        "1",
        "B",
        "2",
        "C",
        "3",
        "D",
        "4",
        "E",
        "5",
        "6",
        "7",
        "8",
      ],
      tooth: {
        lt: [],
        rt: [],
        lb: [],
        rb: [],
      },
    };
  },
  setup() {},

  mounted: function () {},
  created() {
    this.loadermap(this.toothPosition);
  },
  watch: {
    toothPosition(newValue, oldValue) {
      this.loadermap(newValue);
    },
  },
  methods: {
    loadermap(arr) {
      let toothmap = {
        lt: [],
        rt: [],
        lb: [],
        rb: [],
      };
      let tootharr = arr ? arr.split(",") : [];
      let numtofont = function (num) {
        switch (num) {
          case "1":
            return "A";
          case "2":
            return "B";
          case "3":
            return "C";
          case "4":
            return "D";
          case "5":
            return "E";
          default:
            break;
        }
      };
      tootharr.forEach((item) => {
        let c = item[0];
        let c1 = item[1];

        if (c === "1" || c === "5") {
          if (c === "5") {
            toothmap.lt.push(numtofont(c1));
          } else {
            toothmap.lt.push(c1);
          }
        }
        if (c === "2" || c === "6") {
          if (c === "6") {
            toothmap.rt.push(numtofont(c1));
          } else {
            toothmap.rt.push(c1);
          }
        }
        if (c === "3" || c === "7") {
          if (c === "7") {
            toothmap.rb.push(numtofont(c1));
          } else {
            toothmap.rb.push(c1);
          }
        }
        if (c === "4" || c === "8") {
          if (c === "8") {
            toothmap.lb.push(numtofont(c1));
          } else {
            toothmap.lb.push(c1);
          }
        }
      });

      this.tooth = toothmap;
    },
  },
};
</script>

<style lang="scss" scoped>
.toothmapshow {
  width: 100%;
  height: 100%;
  min-height: 0.708rem;
  position: relative;
  margin: 0 auto;
  color: #666;
}

.toothmapshow .heng {
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  top: 50%;
  background-color: #ccc;
  z-index: 5;
}

.toothmapshow .shu {
  position: absolute;
  left: 50%;
  width: 1px;
  height: 100%;
  background-color: #ccc;
  z-index: 5;
}

.toothmapshow .lt {
  position: absolute;
  height: 50%;
  width: 50%;
  background-color: #fff;
  top: 0.14%; // 1px / 0.708rem
  left: 0;
  text-align: right;
  padding: 0 1.16%; // 0.063 / 5.417
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  font-size: 0.25rem;
}

.toothmapshow .rt {
  position: absolute;
  height: 50%;
  width: 50%;
  background-color: #fff;
  top: 0.14%; // 1px / 0.708rem
  left: 50%;
  text-align: left;
  padding: 0 1.16%; // 0.063 / 5.417
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  font-size: 0.25rem;
}

.toothmapshow .lb {
  position: absolute;
  height: 50%;
  width: 50%;
  background-color: #fff;
  top: 50%;
  left: 0;
  text-align: right;
  padding: 0 1.16%; // 0.063 / 5.417
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  font-size: 0.25rem;
}

.toothmapshow .rb {
  position: absolute;
  height: 50%;
  width: 50%;
  background-color: #fff;
  top: 50%;
  left: 50%;
  text-align: left;
  padding: 0 1.16%; // 0.063 / 5.417
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  font-size: 0.25rem;
}
</style>
